<template>
  <div>
    <div v-if="!isCreate && !isBatchTrade">
      <table-search
        @search="fetchList(1)"
        @reset="handleReset"
      >
        <template v-slot:basic>
          <el-form-item
            label="商品类目"
            class="datePicker"
          >
            <el-select
              v-model="query.varietyCode"
              placeholder="请选择"
              clearable
              @change="selectVarietyChange"
            >
              <el-option
                v-for="(item) in varietyList"
                :key="item.code"
                :label="item.shortName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="商品品牌">
            <el-select
              v-model="query.goodsBrandCode"
              placeholder="请选择"
              clearable
              @change="selectBrandChange"
            >
              <el-option
                v-for="item in brandList"
                :key="item.k"
                :label="item.v"
                :value="item.k"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="商品状态">
            <el-select
              v-model="query.status"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in $key.myStore.quotationStatus"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="交货地点"
          >
            <el-input v-model.trim="query.pickupPosition" />
          </el-form-item>
        </template>
      </table-search>

      <el-button
        type="primary"
        class="m-t-10"
        @click="toCreate('add')"
      >
        新增报价
      </el-button>
      <el-button
        type="primary"
        class="m-t-10"
        :disabled="quotationList.length === 0"
        @click="toBatchTrade"
      >
        批量发布挂牌
      </el-button>
      <el-button
        type="primary"
        class="m-t-10"
        @click="toGenerateQuotationImg"
      >
        生成报价单
      </el-button>

      <!-- 导出 -->
      <inquery-result
        :is-export="false"
      />

      <!-- 表格 -->
      <el-table
        ref="zTable"
        :data="tableData"
        @selection-change="handleSelectionChange"
      >
        <af-table-column
          type="selection"
          width="55"
          :selectable="handleSelectable"
        />
        <af-table-column
          prop="varietyName"
          label="商品类目"
        />
        <af-table-column
          label="品牌"
        >
          <template v-slot="scope">
            {{ scope.row.attrList.find(item=>item.attrCode==='brand') ? scope.row.attrList.find(item=>item.attrCode==='brand').v : '' }}
          </template>
        </af-table-column>
        <af-table-column
          prop="priceType"
          label="报价类型"
        >
          <template v-slot="scope">
            {{ scope.row.priceType | keyFilter('myStore','priceType') }}
          </template>
        </af-table-column>
        <af-table-column
          prop="priceList"
          label="报价"
        >
          <template v-slot="scope">
            <div v-if="scope.row.priceType==='YKJ'">
              {{ scope.row.priceList&&scope.row.priceList[0].unitPrice | thousandMark }}
            </div>
            <div v-if="scope.row.priceType==='JTJ'">
              <el-popover
                placement="right"
                trigger="hover"
                width="300"
              >
                <el-table :data="scope.row.priceList">
                  <el-table-column
                    prop="unitPrice"
                    label="单价"
                  >
                    <template slot-scope="scope">
                      {{scope.row.unitPrice | thousandMark}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="min"
                    label="购买量(起购量)"
                  />
                </el-table>
                <el-tag slot="reference">
                  {{ scope.row.priceList && scope.row.priceList.length }}
                </el-tag>
              </el-popover>
            </div>
          </template>
        </af-table-column>
        <af-table-column
          prop="times"
          label="报价次数"
        />
        <af-table-column
          prop="status"
          label="状态"
        >
          <template v-slot="scope">
            {{ scope.row.status | keyFilter('myStore','quotationStatus') }}
          </template>
        </af-table-column>
        <af-table-column
          prop="pickupPosition"
          label="交货地点"
        />
        <af-table-column
          prop="unsettleQty"
          label="操作"
          fixed="right"
        >
          <template v-slot="scope">
            <el-button
              type="text"
              @click="toCreate('detail', scope.row)"
            >
              详情
            </el-button>
            <el-button
              v-if="scope.row.priceType!=='DX'"
              type="text"
              @click="toUpdatePrice(scope.row)"
            >
              更新报价
            </el-button>
            <el-button
              type="text"
              @click="toIssueTrade(scope.row)"
            >
              发布挂牌
            </el-button>
            <el-button
              v-if="scope.row.status==='0'"
              type="text"
              class="red"
              @click="toSetStatus(scope.row, '1')"
            >
              失效
            </el-button>
            <el-button
              v-if="scope.row.status==='1'"
              type="text"
              @click="toSetStatus(scope.row,'0')"
            >
              生效
            </el-button>
          </template>
        </af-table-column>
      </el-table>
      <pagination
        :data="pageData"
        :is-init="false"
        @retrieve="fetchList"
      />
    </div>

    <handle-quotation
      v-if="isCreate"
      :detail-data="detailData"
      :opt-type="optType"
      :variety-list="varietyList"
      :market-code="marketCodes ? marketCodes[0] : ''"
      @close="isCreate=false"
      @refresh="fetchList(1)"
    />

    <update-price
      v-if="updetaPriceVisible"
      :updeta-price-visible="updetaPriceVisible"
      :detail-data="detailData"
      @refresh="fetchList(query.currentNo)"
      @close="updetaPriceVisible=false"
    />

    <issue-trade
      v-if="issueTradeVisible"
      :issue-trade-visible="issueTradeVisible"
      :detail-data="detailData"
      @close="issueTradeVisible=false"
    />

    <batch-trade
      v-if="isBatchTrade"
      :quotation-list="quotationList"
      @close="cancelBatchTrade"
    />

    <generate-quotation-img
      v-if="isGenerateQuotationImg"
      :is-generate-quotation-img="isGenerateQuotationImg"
      :img-data="imgData"
      :storeInfo="storeInfo"
      :contactList="contactList"
      @close="isGenerateQuotationImg=false"
    />
  </div>
</template>
<script>
import api from '@/api'
import HandleQuotation from './components/handle-quotation'
import UpdatePrice from './components/update-price'
import IssueTrade from './components/issue-trade'
import BatchTrade from './components/batch-trade'
import GenerateQuotationImg from './components/quotationImg.vue'
import { mapState } from 'vuex'
import { varietyBrandMixin } from '@/views/my-store/components/mixin'
function Query () {
  return {
    currentNo: '1',
    pageSize: '10',
    varietyCode: '',
    status: '',
    pickupPosition: '',
    attrList: [],
    goodsBrandCode: ''
  }
}
export default {
  name: 'StoreQuotation',
  components: {
    HandleQuotation,
    UpdatePrice,
    BatchTrade,
    GenerateQuotationImg,
    IssueTrade,
  },
  mixins: [varietyBrandMixin],
  data () {
    return {
      query: new Query(),
      tableData: [],
      pageData: {},
      isCreate: false,
      isBatchTrade: false,
      isGenerateQuotationImg: false,
      detailData: {},
      optType: '',
      updetaPriceVisible: false,
      issueTradeVisible: false,
      quotationList: [],
      isReset: false,
      imgData: [],
      varietyList: [],
      storeInfo: {},
      contactList: []
    }
  },
  computed: {
    ...mapState({
      // marketCodes: state => state.user.info.marketCodes
    })
  },
  created () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentNo, pageSize) {
      this.query.currentNo = currentNo || this.query.currentNo
      this.query.pageSize = pageSize || this.query.pageSize
      let res = await api.myStore.getQuotationData(this.query)
      this.tableData = res.data.rows
      this.pageData = res.data
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.isReset = true
      this.fetchList(1)
    },
    // 返回品种和品牌信息
    returnVarietyBrandInfo (data) {
      this.query.goodsBrand.code = data.brandCode
      this.query.varietyCode = data.varietyCode
    },
    // 是否可选
    handleSelectable (row) {
      return row.status === '0'
    },
    async getDetail (row) {
      const res = await api.myStore.getQuotationDetail(row.id)
      return res.data
    },
    async toCreate (type, row) {
      this.optType = type
      if (type === 'detail') {
        this.detailData = await this.getDetail(row)
      }
      this.isCreate = true
    },
    async toUpdatePrice (row) {
      this.detailData = await this.getDetail(row)
      this.updetaPriceVisible = true
    },
    async toIssueTrade (row) {
      this.detailData = await this.getDetail(row)
      this.issueTradeVisible = true
    },
    toBatchTrade () {
      this.isBatchTrade = true
    },
    async toGenerateQuotationImg () {
      this.query.status = '0'
      Promise.all([this.fetchList(1, '999999'), this.getStoreDetail(), this.getContact()]).then(res => {
        this.imgData = this.tableData
        this.storeInfo = res[1] || {}
        this.contactList = res[2] || []
        this.isGenerateQuotationImg = true
      }).catch((err) => {
        console.log(err)
      })
    },
    // 店铺信息
    async getStoreDetail () {
      const res = await api.myStore.getStoreDetail()
      return res.data
    },
    // 获取联系人方式
    async getContact () {
      const res = await api.myStore.getContact(this.$store.state.user.info.userId)
      return res.data
    },
    handleSelectionChange (selection) {
      this.quotationList = selection
    },
    toSetStatus (row, status) {
      this.$confirm(`确认${status === '1' ? '失效' : '生效'}?`, '提示', {
        type: 'warning'
      }).then(() => {
        const param = {
          id: row.id,
          status
        }
        api.myStore.setQuotationStatus(param).then(res => {
          this.$message.success('操作成功')
          this.fetchList(this.query.currentNo)
        })
      }).catch(() => {

      })
    },
    // 取消批量挂牌
    cancelBatchTrade () {
      this.isBatchTrade = false
      this.quotationList = []
    }

  }
}

</script>
